import React, { useState } from 'react';
import Loading from '../Components/Loading';

const withLoading = (Component: React.FC<any>) => {
	return (props: any) => {
		const [loading, setLoading] = useState<boolean>(false);

		return (
			<>
				{loading && (
					<div className={'py-5'}>
						<Loading />
					</div>
				)}
				<Component setLoading={setLoading} {...props} />
			</>
		);
	};
};

export default withLoading;
